"use client";

import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";

import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};

type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};

export default function HorizontalSmallImageCategoryNews({
  category = { hidden: false, value: "POLITICS", customClass: "" },
  sectionUrl,
  title = { hidden: false, value: "ஜே.பி. நட்டா செல்லும் இடமெல்லாம் பாதக தேர்கும்: சற்று ய ரெளத்", customClass: "" },
  timeAgo = { hidden: false, value: "15 min ago", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  priority = false,
  imageMetadata,
  templatetype = { hidden: false, value: "", customClass: "" },
  isliveblog = { hidden: false, value: "", customClass: "" },
}: Props) {
  const titleValue = toFieldString(title?.value);
  const imageSrcValue = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
  const isLiveBlog = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
 
  const content = (
    <article className="p-4">
      <div className="flex gap-3">
        {/* LEFT: IMAGE */}
        {!imageSrc?.hidden && (
          <div className={`relative w-[106px] h-[76px] flex-shrink-0 overflow-hidden ${imageSrc?.customClass || ""}`}>
            <Image
              src={imageSrcValue}
              alt={titleValue}
              width={106}
              height={76}
              className="object-cover !h-[76px]"
              style={getFocusPointStyle(imageMetadata)}
              loading={priority ? "eager" : "lazy"}
              fetchPriority={priority ? "high" : "auto"}
              priority={priority}
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
          </div>
        )}

        {/* RIGHT: CONTENT */}
        <div className="flex flex-col justify-between gap-5 w-full">
          <div className="flex flex-col gap-2">
            {/* Title */}
            {!title?.hidden && (
              <h3 className={`text-14-tamil-700 text-1B1B1B font-medium leading-[1.4] ${title?.customClass || ""}`}>
                {isLiveBlog && (
                  <LiveBlink className="mr-1.5" />
                )}
                {titleValue}
              </h3>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center">
            <MessageIcon
              id="small-news-message-icon"
              slug={slug}
              category={BOOKMARK_CATEGORIES.NEWS}
              title={titleValue}
              thumbnailUrl={imageSrcValue}
              articleUrl={slug ? `/${slug}` : undefined}
            />
          </div>
        </div>
      </div>
    </article>
  );

  // If slug is provided, wrap with Link component for navigation
  if (slug) {
    return (
      <Link href={`/${slug}`} className="block  transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  // Return content without Link if no slug is provided
  return content;
}
